export default {
  home: "/",
  contactUs: "/contact-us",
  listings: "/listings",
};